import { Spinner, Text } from '@/ui-kit'
import { OverlayScrollBars } from '@/ui-kit/components/OverlayScrollbars'
import { Trans } from '@lingui/react/macro'
import { clsx } from 'clsx'
import styles from '../../devices/components/DevicesList/DevicesTable.module.css'
import { ReferralsListProps } from './ReferralsList'

export const ReferralsTable = ({ columns, referrals = [] }: ReferralsListProps) => {
  return (
    <OverlayScrollBars>
      {!!referrals.length && (
        <table className={clsx(styles.table, 'max-mobile:mt-1 table w-full min-w-[500px] table-auto')}>
          <thead>
            <tr>
              <th key={'place'} className={clsx(styles.th)}>
                <Text className="text-gray-90 whitespace-nowrap">
                  <Trans>Place</Trans>
                </Text>
              </th>
              {columns.map((column) => (
                <th key={column.name} className={clsx(styles.th, column.cellClassName)}>
                  <Text className="text-gray-90 whitespace-nowrap">{column.name}</Text>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="pt-5">
            {referrals.map((referral, index) => (
              <tr key={referral.email} className={clsx(styles.row)}>
                <td key={`${referral.email}_place`} className={clsx(styles.cell)}>
                  <Text>{index + 1}</Text>
                </td>
                {columns.map((column) => (
                  <td key={`${referral.email}_${column.name}`} className={clsx(styles.cell, column.cellClassName)}>
                    <Text>{column.value(referral)}</Text>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {referrals === undefined ? (
        <Spinner className="mx-auto mt-4 mb-2" />
      ) : (
        !referrals.length && (
          <div className="m-auto max-w-[350px] rounded-xl bg-[var(--color-gray-100)] p-6 text-center">
            <Text>
              <Trans>No data available yet</Trans>
            </Text>
          </div>
        )
      )}
    </OverlayScrollBars>
  )
}
